<template>
    <console-content max-width="1200px">
        <v-row align="center" class="mt-3">
            <v-col cols="auto" class="headline">정산</v-col>
        </v-row>

        <v-row class="mt-4" no-gutters align="end">
            <v-col cols="auto">
                <v-month-field v-model="filter.month" class="mx-auto" label="검색일자" placeholder=" " hide-details @input="search"></v-month-field>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="white" @click="excel" class="green--text px-2">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="calculationsHeaders" :items="calculations" :loading="loading" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
            <template v-slot:item.count="{ item }">
                <span v-if="item.pay" class="d-inline-block text-end">
                    <div v-for="(pay, place) in item.pay" :key="place">
                        {{ place }}: <span class="font-weight-bold">{{ pay?.count?.format()}}</span> 건
                    </div>
                </span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.price="{ item }">
                <span v-if="item.pay" class="d-inline-block text-end">
                    <div v-for="(pay, place) in item.pay" :key="place">
                        {{ place }}: <span class="font-weight-bold">{{ pay?.price?.format()}}</span> 원
                    </div>
                </span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.pnos="{ item }">
                <span v-if="item.pay" class="d-inline-block text-end">
                    <div v-for="(pay, place) in item.pay" :key="place">
                        {{ place }}: 
                        <v-icon color="green" size="20" class="mr-2" @click="excelPnos(item.ymd, place, pay.pnos)">{{ mdiMicrosoftExcel }}</v-icon>
                    </div>
                </span>
                <span v-else>-</span>
            </template>
        </v-data-table>

        <div class="headline text-start mt-8">합계</div>
        <v-data-table :headers="totalCalculationsHeaders" :items="[total]" :loading="loading" disable-sort
            disable-pagination hide-default-footer class="elevation-1 mt-4">
            <template v-slot:item.count="{ item }">
                <span v-if="item.pay" class="d-inline-block text-end">
                    <div v-for="(pay, place) in item.pay" :key="place">
                        {{ place }}: <span class="font-weight-bold">{{ pay?.count?.format()}}</span> 건
                    </div>
                </span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.price="{ item }">
                <span v-if="item.pay" class="d-inline-block text-end">
                    <div v-for="(pay, place) in item.pay" :key="place">
                        {{ place }}: <span class="font-weight-bold">{{ pay?.price?.format()}}</span> 원
                    </div>
                </span>
                <span v-else>-</span>
            </template>
        </v-data-table>
    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/components/console/console-content.vue";
import VMonthField from "@/components/plugins/vuetify/v-month-field.vue";

import XLSX from 'xlsx';
import dayjs from "dayjs";
import { mdiMicrosoftExcel } from '@mdi/js';

export default {
    components: {
        ConsoleContent,
        VMonthField
    },
    data() {
        return {
            mdiMicrosoftExcel,

            loading: true,

            filter: {
                month: dayjs().format("YYYY-MM"),
                _cp: null,
                place: null,
            },

            calculations: [],
            calculationsHeaders: [
                { text: "날짜", align: "center", value: "ymd" },
                { text: "사용(건)", align: "center", value: "count" },
                { text: "사용(금액)", align: "center", value: "price" },
                { text: "핀번호 다운로드", align: "center", value: "pnos" },
            ],

            totalCalculationsHeaders: [
                { text: "날짜", align: "center", value: "ymd" },
                { text: "사용(건)", align: "center", value: "count" },
                { text: "사용(금액)", align: "center", value: "price" },
            ],

            cps: []
        };
    },

    mounted(){
        this.init();
    },

    methods: {
        async init(){
            var { me } = await api.console.me.get();
            this.categories = me.categories;

            var { cps } = await api.console.me.cps.gets({ headers: { limit: 0 } });
            this.cps = [
                { name: ":: 전체 ::", _id: null },
                ...cps
            ]

            this.search();
        },

        async search(){
            this.loading = true;

            var { calculations } = await api.console.pins.calculations({
                params: this.filter
            });

            this.calculations = calculations;
            this.loading = false;
        },

        excel(){
            var data = [];
            for(var calculation of [...this.calculations, this.total]){
                let row = {
                    "날짜": calculation.ymd,
                };

                for(let place in calculation.pay){
                    row[`${place} 사용(건)`] = calculation?.pay?.[place].count.format() + " 건";
                    row[`${place} 사용(금액)`] = calculation?.pay?.[place].price.format() + " 원";
                }
                data.push(row);
            }

            var workBook = new XLSX.utils.book_new();
            var workSheet = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(workBook, workSheet, "new");
            XLSX.writeFile(workBook, "정산 목록 " + this.filter.month + ".xlsx");
        },

        excelPnos(ymd, place, pnos){
            var data = [];
            for(var pno of pnos){
                let row = {
                    "핀번호": pno
                }
                data.push(row);
            }

            var workBook = new XLSX.utils.book_new();
            var workSheet = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(workBook, workSheet, "new");
            XLSX.writeFile(workBook, `${ymd}_${place}_핀번호` + ".xlsx");
        }
    },
    computed: {
        total(){
            var total = {
                ymd: this.filter.month,
                pay: {}
            };

            console.log({ calculations: this.calculations });
            for(var calculation of this.calculations){
                for(var place in calculation.pay){
                    total.pay[place] = {
                        count: parseInt(total.pay?.[place]?.count || 0) + parseInt(calculation.pay[place].count),
                        price: parseInt(total.pay?.[place]?.price || 0) + parseInt(calculation.pay[place].price)
                    }
                }
            }

            return total;
        },
    },
}
</script>
